import React from 'react';
import {Box, Stack} from '@mui/material';

import EvolutionOfOperationsChart from '@components/statistics/charts/EvolutionOfOperations.chart';
import TonnageChart from '@components/statistics/charts/Tonnage.chart';
import ValoWeightByWasteFamilyChart from '@components/statistics/charts/ValoWeightByWasteFamily.chart';
import ExecutionCountChart from '@components/statistics/charts/ExecutionCount.chart';
import {useTranslation} from 'react-i18next';
import {useObservable} from '@ngneat/react-rxjs';
import {statisticsQuery} from '@store/statistics';

const OperationsTab = () => {

  const {t} = useTranslation();

  const [{executionCountPickup, loading: pLoading}] = useObservable(statisticsQuery.execCountPickup$);
  const [{executionCountProcessingValo, loading: pvLoading}] = useObservable(statisticsQuery.execCountProcessing$);
  const [{executionCountOther, loading: oLoading}] = useObservable(statisticsQuery.execCountOther$);
  const [{executionCountRenting, loading: rLoading}] = useObservable(statisticsQuery.execCountRenting$);
  const [{executionCountAll, loading: aLoading}] = useObservable(statisticsQuery.execCountAll$);


  return (
    <Stack flex={1} spacing={3} direction="column">
      <Stack spacing={3} flex={1}>
        <Box flex={0.5}>
          <EvolutionOfOperationsChart/>
        </Box>
        <Box flex={0.5}>
          <Stack direction="row" spacing={3}>
            <TonnageChart/>
          </Stack>
        </Box>
        <Stack>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
              <Box flex={0.5}>
                <ValoWeightByWasteFamilyChart/>
              </Box>
              <Box flex={0.5}>
                <ExecutionCountChart title={t('dashboard.statistics.operations.execCount.allTitle')}
                                     executionCountByServiceKind={executionCountAll} loading={aLoading}/>
              </Box>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Box flex={0.5}>
                <ExecutionCountChart title={t('dashboard.statistics.operations.execCount.pickupTitle')}
                                     executionCountByServiceKind={executionCountPickup} loading={pLoading}/>
              </Box>
              <Box flex={0.5}>
                <ExecutionCountChart title={t('dashboard.statistics.operations.execCount.processingValoTitle')}
                                     executionCountByServiceKind={executionCountProcessingValo}
                                     loading={pvLoading}/>
              </Box>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Box flex={0.5}>
                <ExecutionCountChart title={t('dashboard.statistics.operations.execCount.rentingTitle')}
                                     executionCountByServiceKind={executionCountRenting} loading={rLoading}/>
              </Box>
              <Box flex={0.5}>
                <ExecutionCountChart legendFontSize={9}
                                     title={t('dashboard.statistics.operations.execCount.otherTitle')}
                                     executionCountByServiceKind={executionCountOther} loading={oLoading}/>
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default OperationsTab;
